import React from 'react';
import { Terminal, Shield, HelpCircle } from 'lucide-react';

export const LogsPage: React.FC = () => (
    <div className="h-full flex flex-col p-1">
        <div className="flex-1 bg-white border border-neutral-200 rounded-lg overflow-hidden flex flex-col shadow-sm">

            {/* Toolbar */}
            <div className="flex items-center justify-between p-2 border-b border-neutral-200 bg-neutral-50/50">
                <span className="text-xs font-semibold text-neutral-500 uppercase tracking-wider px-2">System Logs</span>
            </div>

            <div className="flex-1 bg-neutral-900 text-green-400 p-4 font-mono text-sm overflow-y-auto">
                <div className="flex items-center gap-2 text-neutral-500 mb-4 border-b border-neutral-800 pb-2">
                    <Terminal size={14} /> <span>Console Output</span>
                </div>
                <div className="space-y-1">
                    <p className="text-neutral-500 italic">No logs available.</p>
                    <p className="animate-pulse">{'>'} _</p>
                </div>
            </div>
        </div>
    </div>
);

export const AuditTrailPage: React.FC = () => (
    <div className="h-full flex flex-col p-1">
        <div className="flex-1 bg-white border border-neutral-200 rounded-lg overflow-hidden flex flex-col shadow-sm">

            {/* Toolbar */}
            <div className="flex items-center justify-between p-2 border-b border-neutral-200 bg-neutral-50/50">
                <span className="text-xs font-semibold text-neutral-500 uppercase tracking-wider px-2">Audit Trail</span>
            </div>

            <div className="flex-1 flex flex-col items-center justify-center p-12 text-center text-neutral-400">
                <Shield size={32} className="mb-4 text-neutral-300" />
                <p className="text-sm">Security audit logs and access history.</p>
            </div>
        </div>
    </div>
);

export const SupportPage: React.FC = () => (
    <div className="h-full flex flex-col p-1">
        <div className="flex-1 bg-white border border-neutral-200 rounded-lg overflow-hidden flex flex-col shadow-sm">

            {/* Toolbar */}
            <div className="flex items-center justify-between p-2 border-b border-neutral-200 bg-neutral-50/50">
                <span className="text-xs font-semibold text-neutral-500 uppercase tracking-wider px-2">Support & Tickets</span>
            </div>

            <div className="flex-1 flex flex-col items-center justify-center p-12 text-center text-neutral-400">
                <HelpCircle size={32} className="mb-4 text-neutral-300" />
                <p className="text-sm">Support dashboard and ticket management.</p>
            </div>
        </div>
    </div>
);
